import React from "react";

const IntraTableMessage = ({ children }) => {
  return <div className="intra-table-message">{children}</div>;
};

export default IntraTableMessage;
